import { Injectable } from '@angular/core';
import { ExportContext, ExportFileFormat, ExportRange, ExportService } from 'app/layout/export-overlay';
import { buildQuery, page, seed } from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { takeUntil } from 'rxjs';
import get from 'lodash-es/get';
import ceil from 'lodash-es/ceil';
import { SubRouteService } from '../sub-route.service';
import { SubRouteAttributes } from '@albatrosdeveloper/ave-models-package';
import { LOCALIZED_PROPERTIES, SUB_ROUTE_EXPORT_ID, SUB_ROUTE_TITLE } from './sub-route.constants';

@Injectable()
export class SubRouteExport {
  constructor(
    private exportService: ExportService,
    private subRouteService: SubRouteService,
  ) { }

  private transformItem(item: SubRouteAttributes) {
    const routes = Array.isArray(item.routes)
      ? item.routes
      : [{ name: get(item, 'routes.name', '??'),
           code: get(item, 'routes.externalKeys.code', '??') 
       }];

    const routeAreas = Array.isArray(item.routeAreas)
      ? item.routeAreas
      : [{ name: get(item, 'routeAreas.name', '??'),
           code: get(item, 'routeAreas.id', '??') 
       }];
    return routes.flatMap(route =>
      routeAreas.map(area => ({
        externalKeys: get(item, 'externalKeys.code', '??'),
        name: get(item, 'name', '??'),
        company: get(item, 'company.name', '??'),
        routeCode: route?.externalKeys?.code ?? '',   
        routes: route?.name ?? '',  // Nombre de la ruta actual
        routeAreaCode: area?.id ?? '',
        routeAreas: area?.name ?? '', // Nombre del área de ruta actual
        statusId: this.getStatus(get(item, 'statusId', '')),
      }))
    );
  }

  private getStatus(value: string | number): string {
    if (!value && value !== 0) {
      return '';
    }
    return value === 1 ? 'Activo' : 'Inactivo';
  }

  export(format: ExportFileFormat, range: ExportRange, totalItems: number, pageSize: number, pageIndex: number) {
    const totalPages = ceil(totalItems / pageSize) + 1;
    this.exportService.task({
      id: SUB_ROUTE_EXPORT_ID,
      title: SUB_ROUTE_TITLE,
      format: format,
      iterations: range === ExportRange.AllPages ? totalPages : 1,
      start: (ctx: ExportContext) => {
        ctx.processor.localizeItemProperties(SUB_ROUTE_TITLE, LOCALIZED_PROPERTIES);
      },
      next: (ctx: ExportContext) => {
        const currentPage = range === ExportRange.AllPages ? ctx.iteration : pageIndex;
        this.subRouteService.findByFilter(buildQuery(
          seed(this.subRouteService.currentFilter), page(currentPage, pageSize)
        ), { contextHeader: 'export' }).pipe(takeUntil(ctx.stopped)).subscribe((response) => {
          //   get(response, 'data.0.data', []).map((item) => {
          //     ctx.processor.addToSection(SUB_ROUTE_TITLE, this.transformItem(item));
          //   });
          //   ctx.next();
          // });
          const items = get(response, 'data.0.data', []);

          const exportData = items.flatMap(item => this.transformItem(item));

          exportData.forEach(data => {
            ctx.processor.addToSection(SUB_ROUTE_TITLE, data);
          });

          ctx.next();
        });
      },
    }).start();
  }

  canStartTask() {
    if (this.exportService.taskIsActive(SUB_ROUTE_EXPORT_ID)) {
      this.exportService.setVisible(true);
      return false;
    }
    return true;
  }
}
